import DumbArticle from '../../cards/dumbArticle'
import episodes from '../../../episodes'
import { useEffect, useState } from 'react'
import { Section } from '../../core/section/Section'
import s from './RandomArticles.module.scss'
import { Text } from '../../core/text/Text'

type Props = {
    showPodcast?: boolean
    showHagnytar?: boolean
    showFraedslugreinar?: boolean
}

export default function RandomArticles({
    // hidden (podcast, hagnytar..) = true / false
    showPodcast = true,
    showHagnytar = true,
    showFraedslugreinar = true,
}: Props) {
    const [articles, setArticles] = useState([])

    useEffect(() => {
        async function data() {
            const ref = await fetch('https://minningar.prismic.io/api/v2/')
                .then((response) => response.json())
                .then((result) => result.refs[0].ref)

            const fraedslugreinar = await fetch(
                `https://minningar.prismic.io/api/v2/documents/search?q=[[any(document.type,["frodleikur-grein"])]]&orderings=[document.first_publication_date desc]&ref=${ref}&access_token=MC5Za0xycHhJQUFDd0FtVWdr.77-9QO-_vSdPK--_vRnvv73vv71pBDlKd--_ve-_ve-_ve-_ve-_ve-_ve-_vVDvv70caO-_ve-_ve-_vR1cfg`
            )
                .then((response) => response.json())
                .then((result) => result)

            const hagnytar = await fetch(
                `https://minningar.prismic.io/api/v2/documents/search?q=[[any(document.type,["blog"])]]&orderings=[document.first_publication_date desc]&ref=${ref}&access_token=MC5Za0xycHhJQUFDd0FtVWdr.77-9QO-_vSdPK--_vRnvv73vv71pBDlKd--_ve-_ve-_ve-_ve-_ve-_ve-_vVDvv70caO-_ve-_ve-_vR1cfg`
            )
                .then((response) => response.json())
                .then((result) => result)

            let list = []
            // hagnýtar greinar
            if (showHagnytar) {
                hagnytar.results.map((item) => {
                    const obj = {
                        imgSrc:
                            item.data.shareimage.url ||
                            item.data.slices[0].primary.image.url,
                        tag: 'Hagnýtt',
                        date: item.first_publication_date,
                        title: item.data.titill[0].text,
                        paragraph:
                            (item.data.slices[0].primary.title &&
                                item.data.slices[0].primary.title[0].text) ||
                            item.data.slices?.data.sharedescription,
                        link: '/advice/' + item.uid,
                    }

                    list.push(obj)
                })
            }

            // fræðslugreinar
            if (showFraedslugreinar) {
                fraedslugreinar.results.map((item) => {
                    if (
                        item.uid === 'thorarinn-eldjarn' ||
                        item.uid === 'sera-jona-hronn-bolladottir'
                    ) {
                        return
                    }

                    const obj = {
                        imgSrc:
                            item.data.shareimage.url ||
                            item.data.slices[0].primary.image.url,
                        tag: 'Viðtal',
                        date: item.first_publication_date,
                        title: item.data.titill[0].text,
                        paragraph: item.data.body[0].primary.title[0].text,
                        link: '/articles/' + item.uid,
                    }

                    list.push(obj)
                })
            }

            // podcast
            if (showPodcast) {
                episodes.map((item) => {
                    const obj = {
                        imgSrc: item.thumbnail,
                        tag: 'Hlaðvarp',
                        date: item.date,
                        title: item.title,
                        paragraph: item.paragraph,
                        link: '/podcast?vidId=' + item.videoId,
                    }
                    list.push(obj)
                })
            }
            const shuffled = list.sort(() => 0.5 - Math.random())

            let selected = shuffled.slice(0, 2)

            return await selected
        }

        data().then((result) => {
            setArticles(result)
        })
    }, [])

    return (
        <Section container>
            <Text variant="h5" className={s.header}>
                Tengdar greinar
            </Text>
            {articles.map((art, i) => {
                return (
                    <DumbArticle
                        key={i}
                        {...art}
                        first
                        smallText
                        className={s[`dumb_${i + 1}`]}
                    />
                )
            })}
        </Section>
    )
}
